<template>
   <pb-body-base :busy="busy">
      <template v-slot:default="props">
         <pb-body>
            <template slot="title">
               <b-container>
                  <b-row class="mt-7 mb-2">
                     <b-col class="text-center">
                        <b-row class="justify-content-center">
                           <b-col class="col-auto">
                              <img width="250px" :src="fileResourceUrl(employee.image)" :alt="employee.name"/>
                              <br/>
                              <br/>
                           </b-col>
                        </b-row>
                        <h3>{{ employee.name }}</h3>
                        <h4>{{ employee.departmentName }}</h4>
                        <hr class="center"/>
                     </b-col>
                  </b-row>
               </b-container>
            </template>
            <template slot="body">
               <b-row class="justify-content-center">
                  <b-col class="col-auto">
                     <b-row>
                        <b-col class="col-auto">
                           <i class="fal fa-location-circle"></i>
                        </b-col>
                        <b-col>
                           <p>
                              Peter Büdel GmbH<br>
                              Im Gewerbegebiet 13<br>
                              63846 Laufach<br>
                           </p>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col class="col-auto">
                           <i class="fal fa-phone"></i>
                        </b-col>
                        <b-col>
                           <p>{{ employee.phone }}</p>
                        </b-col>
                     </b-row>
                     <b-row v-if="employee.mobil">
                        <b-col class="col-auto">
                           <i class="fal fa-mobile"></i>
                        </b-col>
                        <b-col>
                           <p>{{ employee.mobil }}</p>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col class="col-auto">
                           <i class="fal fa-envelope"></i>
                        </b-col>
                        <b-col>
                           <p>{{ employee.email }}</p>
                        </b-col>
                     </b-row>
                     <b-row v-if="employee.linkedin && employee.linkedin.includes('linkedin')">
                        <b-col class="col-auto">
                           <i class="fal fa-linkedin"></i></b-col>
                        <b-col>
                           <p><a target="_blank" :href="'https://' + employee.linkedin"><img height="20px" src="@shared/_assets/img/LI-Logo.png"/></a></p>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col>
                           <b-button @click="downloadVCard" class="w-100"><i class="fal fa-plus"></i> add to my contacts
                           </b-button>
                        </b-col>
                     </b-row>
                  </b-col>
               </b-row>

            </template>
         </pb-body>
      </template>
   </pb-body-base>
</template>

<script>
import EmployeeApi from "@shared/_api/employee";

export default {
   name: 'employee-details',
   data() {
      return {
         employee: {},
         breadcrumbs: [{
            text: "Team",
            href: '/team'
         },
            {
               text: "Employee",
               href: ''  // initially empty
            }],
         busy: false
      }
   },

   mounted() {
      this.busy = true;
      const employeeId = this.$route.params.employeeId;

      EmployeeApi.fetchById(employeeId)
          .then(data => {
             this.employee = data;

             this.breadcrumbs[1].href = '/employee/' + data.id;
          }).finally(() => {
         this.busy = false;
      });
   },

   methods: {
      downloadVCard() {
         const vCardData = this.generateVCard(this.employee);
         const blob = new Blob([vCardData], {type: 'text/vcard'});
         const url = URL.createObjectURL(blob);
         const a = document.createElement('a');
         a.style.display = 'none';
         a.href = url;
         a.download = `${this.employee.name}.vcf`;

         document.body.appendChild(a);
         a.click();
         window.URL.revokeObjectURL(url);
      },
      generateVCard(employee) {
         return `
BEGIN:VCARD
VERSION:3.0
FN:${employee.name}
ORG:Peter Büdel GmbH
TEL:${employee.phone}
EMAIL:${employee.email}
ADR:;;Im Gewerbegebiet 13;Laufach;;63846;
END:VCARD
         `.trim();
      }
   },
}
</script>

<!-- You can also add specific styles if needed -->
